import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FiHome, FiBook, FiCalendar, FiSettings, FiLogOut, FiX, FiMail, FiUserPlus, FiCheckCircle, FiUserCheck, FiExternalLink } from 'react-icons/fi';
import { logout } from '../../Redux/slices/authSlice';

const AdminSidebar = ({ sidebarOpen, setSidebarOpen, currentPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // Dispatch logout action to clear Redux state and localStorage
    dispatch(logout());
    // Redirect to login page
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: FiHome, label: 'Dashboard', key: 'dashboard' },
    { path: '/admin/sermons', icon: FiBook, label: 'Sermons', key: 'sermons' },
    { path: '/admin/events', icon: FiCalendar, label: 'Events', key: 'events' },
    { path: '/admin/ministry-requests', icon: FiCheckCircle, label: 'Ministry Requests', key: 'ministry-requests' },
    { path: '/admin/ministry-members', icon: FiUserCheck, label: 'Ministry Members', key: 'ministry-members' },
    { path: '/admin/messages', icon: FiMail, label: 'Messages', key: 'messages' },
    { path: '/admin/subscribers', icon: FiUserPlus, label: 'Subscribers', key: 'subscribers' },
    { path: '/admin/settings', icon: FiSettings, label: 'Settings', key: 'settings' },
  ];

  return (
    <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-blue-900 text-white transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
      <div className="flex items-center justify-between p-6 border-b border-blue-800">
        <h1 className="text-xl font-bold">Admin Panel</h1>
        <button onClick={() => setSidebarOpen(false)} className="lg:hidden">
          <FiX size={24} />
        </button>
      </div>

      <nav className="p-4 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.key}
            to={item.path}
            className={`flex items-center space-x-3 p-3 rounded-lg transition ${
              currentPage === item.key
                ? 'bg-blue-800 hover:bg-blue-700'
                : 'hover:bg-blue-800'
            }`}
          >
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="absolute bottom-0 w-full p-4 border-t border-blue-800 space-y-2">
        <Link
          to="/"
          className="flex items-center space-x-3 p-3 rounded-lg bg-green-700 hover:bg-green-600 transition w-full"
        >
          <FiExternalLink size={20} />
          <span>View Website</span>
        </Link>
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-800 transition w-full"
        >
          <FiLogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
